function getStorage(type: 'localStorage' | 'sessionStorage'): Storage | null {
  try {
    return window[type];
  } catch (error) {
    return null;
  }
}

export function safeLocalStorageGetItem(key: string): string | null {
  const storage = getStorage('localStorage');
  if (!storage) {
    return null;
  }

  try {
    return storage.getItem(key);
  } catch (error) {
    return null;
  }
}

export function safeLocalStorageSetItem(key: string, value: string): void {
  const storage = getStorage('localStorage');
  if (!storage) {
    return;
  }

  try {
    storage.setItem(key, value);
  } catch (error) {
    // Ignore storage write failures (private mode / embedded webviews)
  }
}

export function safeLocalStorageRemoveItem(key: string): void {
  const storage = getStorage('localStorage');
  if (!storage) {
    return;
  }

  try {
    storage.removeItem(key);
  } catch (error) {
    // Ignore storage remove failures (private mode / embedded webviews)
  }
}

export function safeSessionStorageGetItem(key: string): string | null {
  const storage = getStorage('sessionStorage');
  if (!storage) {
    return null;
  }

  try {
    return storage.getItem(key);
  } catch (error) {
    return null;
  }
}

export function safeSessionStorageSetItem(key: string, value: string): void {
  const storage = getStorage('sessionStorage');
  if (!storage) {
    return;
  }

  try {
    storage.setItem(key, value);
  } catch (error) {
    // Ignore storage write failures (private mode / embedded webviews)
  }
}

export function safeSessionStorageRemoveItem(key: string): void {
  const storage = getStorage('sessionStorage');
  if (!storage) {
    return;
  }

  try {
    storage.removeItem(key);
  } catch (error) {
    // Ignore storage remove failures (private mode / embedded webviews)
  }
}
